import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
type StringProps = {
  value: string
  interval: number
}
type UidProps = Omit<StringProps, 'interval'>

const StringFormatter = ({ value, interval }: StringProps) => {
  // Format the value for display
  const formatForDisplay = (text: string, interval: number) => {
    const regex = new RegExp(`.{1,${interval}}`, 'g')
    const result: string[] = []
    let match

    while ((match = regex.exec(text)) !== null) {
      result.push(match[0])
    }

    return result.join(' ')
  }

  // Handle copy event
  const handleCopy = (e: React.ClipboardEvent) => {
    // Prevent default to avoid copying the formatted text
    e.preventDefault()

    // Copy the original value
    navigator.clipboard.writeText(value)
  }

  return (
    <Box
      component="span"
      sx={{
        // fontSize: '0.875rem',
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'copy',
        wordSpacing: '0.5em',
        letterSpacing: '0.5px',
        whiteSpace: 'nowrap !important', // Override any DataGrid styles
        overflow: 'visible !important', // Override DataGrid overflow hidden
        textOverflow: 'clip !important', // Override ellipsis
        display: 'inline !important', // Ensure proper rendering
        width: 'auto !important', // Allow text to display fully
        // Store original value as data attribute
        '&::after': {
          display: 'none',
          content: 'attr(data-original-value)',
        },
      }}
      onCopy={handleCopy}
      data-original-value={value}
    >
      {formatForDisplay(value, interval)}
    </Box>
  )
}

export const Uid = ({ value }: UidProps) => (
  <StringFormatter value={value} interval={4} />
)

type fotaStateProps = {
  state: string
}

export const FotaJobStateFormatter = ({ state }: fotaStateProps) => {
  const { t } = useTranslation('app')
  return (
    <>
      {t(`device.fotaJobs.states.${state}`, {
        defaultValue: state,
      })}
    </>
  )
}

type IsOnlineProps = {
  value: boolean
}
export const IsOnline = ({ value }: IsOnlineProps) => {
  const { t } = useTranslation('common')
  return <>{value ? t('general.yes') : t('general.no')}</>
}

export const dateTimeFormatter = (value: string): string =>
  new Intl.DateTimeFormat('default', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  }).format(Date.parse(value))

export const DateTime = ({ value }: { value: string }) => {
  if (!value) return null
  return <>{dateTimeFormatter(value)}</>
}
